import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Filtros
//import { ListaMovilesComponent } from 'src/app/shared/sidebar/lista-moviles/lista-moviles.component';
//import { ListaMovilComponent } from 'src/app/shared/sidebar/lista-movil/lista-movil.component';
import { CuentaComponent } from './cuenta/cuenta.component';
import { AdminControlVehiculos } from './control-vehiculos/control-vehiculos.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuariosRoadshowComponent } from './usuarios-roadshow/usuarios-roadshow.component';
import { SupervisoresComponent } from './supervisores/supervisores.component';
import { MotivosNoEntregaComponent } from './motivos-no-entrega/motivos-no-entrega.component';
import { GruposComponent } from './grupos/grupos.component';
import { ChoferesComponent } from './choferes/choferes.component';
import { AccesosAlSistemaComponent } from './accesos-al-sistema/accesos-al-sistema.component';
import { InformesPericialesComponent } from './informes-periciales/informes-periciales.component';

import { GrupoReferenciaComponent } from './grupos-referencias/grupo-referencia.component';
import { ArchivoRoadshowComponent } from './archivo-roadshow/archivo-roadshow.component';
import { ImportarPuntosComponent } from './importar-puntos/importar-puntos.component';
import { ImportarGpxComponent } from './importar-gpx/importar-gpx.component';

import { UpgradeComponent } from './upgrade/upgrade.component';
import { ContactosComponent } from './contact/contactos/contactos.component';

const routes: Routes = [        
    // {
    //     path: '',
    //     redirectTo: 'lista',
    //     pathMatch: 'full'
    // },

    //SECTOR ADMINISTRACION
    {
        path: 'cuenta',
        component: CuentaComponent,
        data: {
            title: 'Cuenta'
        },
    },
    {
        path: 'control-vehiculos',
        component: AdminControlVehiculos,
        data: {
            title: 'Control de Vehiculos'
        },
    },
    {
        path: 'usuarios',
        component: UsuariosComponent,
        data: {
            title: 'Usuarios'
        },
    },
    {
        path: 'usuarios-roadshow',
        component: UsuariosRoadshowComponent,
        data: {
            title: 'Usuarios Roadshow'
        },
    },
    {
        path: 'supervisores',
        component: SupervisoresComponent,
        data: {
            title: 'Supervisores'
        },
    },
    {
        path: 'motivos-no-entrega',
        component: MotivosNoEntregaComponent,
        data: {
            title: 'Motivos no Entrega'
        },
    },
    {
        path: 'grupos',
        component: GruposComponent,
        data: {
            title: 'Grupos'
        },
    },
    {
        path: 'choferes',
        component: ChoferesComponent,
        data: {
            title: 'Choferes'
        },
    },
    {
        path: 'accesos-al-sistema',
        component: AccesosAlSistemaComponent,
        data: {
            title: 'Acceso al Sistema'
        },
    },
    {
        path: 'informes-periciales',
        component: InformesPericialesComponent,
        data: {
            title: 'Informes Periciales'
        },
    },


    //SECTOR HERRAMIENTAS
    {
        path: 'grupos-referencia',
        component: GrupoReferenciaComponent,
        data: {
            title: 'Grupos de Referencia'
        },
    },   
    {
        path: 'archivo-roadshow',
        component: ArchivoRoadshowComponent,
        data: {
            title: 'Archivo Roadshow'
        },
    },
    {
        path: 'importar-puntos',
        component: ImportarPuntosComponent,
        data: {
            title: 'Importar Puntos'
        },
    },
    {
        path: 'importar-gpx',
        component: ImportarGpxComponent,
        data: {
            title: 'Importar GPX'
        },
    }, 



    //SECTOR AYUDA
    {
        path: 'upgrade',
        component: UpgradeComponent,
        data: {
            title: 'Actualizaciones'
        },
    },
    {
        path: 'contactos',
        component: ContactosComponent,
        data: {
            title: 'Contactos'
        }
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [
    ],
    providers: [
    ]
})

export class AdminRouting {}
